<template>
  <vx-card title="User Profile">
    <vs-row vs-justify="center">
      <vs-col vs-xs="12" vs-sm="8" vs-lg="6">
        <form>

          <upload-image
            :src="userData.photoURL "
            @upload-success="userData.photoURL  = $event"
            label="Icon"
            :w="300"
            :h="300"
            folder="upload/user/profile_picture"
          />

          <vs-input class="w-full mt-5" label="Display Name" v-model="userData.displayName" />
          <vs-input class="w-full mt-5" label="Email" v-model="userData.email" />

          <div class="mt-10" v-if="changePassword">
            <vs-input type="password" class="w-full" label="Password" v-model="userData.password" />
            <vs-input type="password" class="w-full mt-5" label="Confirm Password" v-model="userData.password" />
          </div>

          <vs-button icon="save" class="mt-10 ml-auto" @click="saveChanges">Save</vs-button>
        </form>
      </vs-col>
    </vs-row>
  </vx-card>
</template>


<script>
import firebase from 'firebase/app'
import 'firebase/auth'

  export default {
    data() {
      return {
        changePassword: false,
        userData: {}
      }
    },
    computed: {
      computedUserData() {
        let userData = {
          uid: ''
        }
        if (firebase.auth().currentUser) userData = firebase.auth().currentUser

        this.userData = {
          displayName: userData.displayName,
          email: userData.email,
          photoURL : userData.photoURL
        }

        return userData
      }
    },
    watch: {
      'computedUserData.uid': (val) => {
        console.log('changed', val.email)
      }
    },
    methods: {
      saveChanges () {
        this.computedUserData.updateProfile(this.userData)
          .then(() => {
            this.notifySuccess('Profile updated.')
          })
      }
    }
  }
</script>
